<template>
  <el-dialog :title="title" :visible.sync="showDialog" :width="width" :append-to-body="true" @close="hiddenCropper">
    <div class="content">
      <div class="cropper-box">
        <VueCropper ref="cropper" :can-move="true" :auto-crop="true" :fixed="true" :fixed-number="fixedNumber" :img="cropperImg" output-type="png" @realTime="realTime" />
      </div>
      <div class="preview">
        <div class="preview-name">预览</div>
        <img :src="previewImg" :style="{ width: previewWidth, height: previewHeight, 'border-radius': previewRadius }" class="preview-img" />
      </div>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button type="primary" @click="submitImage">{{ saveButtonTitle }}</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { VueCropper } from "vue-cropper"
export default {
  name: "EditImage",
  components: {
    VueCropper
  },
  //这里用props好像不太合适，建议用data
  props: {
    width: {
      type: String,
      default: "450px"
    },
    title: {
      type: String,
      default: "编辑头像"
    },
    saveButtonTitle: {
      type: String,
      default: "开始上传"
    },
    show: {
      type: Boolean,
      default: false
    },
    fixedNumber: {
      type: Array,
      default: () => {
        return [1, 1]
      }
    },
    previewWidth: {
      type: String,
      default: "70px"
    },
    previewHeight: {
      type: String,
      default: "70px"
    },
    previewRadius: {
      type: String,
      default: "35px"
    },
    file: [File],
    image: String
  },
  data() {
    return {
      showDialog: false,
      cropperImg: "",
      previewImg: ""
    }
  },
  watch: {
    show: {
      handler(val) {
        this.showDialog = val
      },
      deep: true,
      immediate: true
    },
    image: function(val) {
      //console.log(11111)
      //即上传过来的原图片
      this.cropperImg = val
    }
  },
  mounted() {
    //console.log(22222)
    //this.cropperImg = this.image
  },
  methods: {
    realTime() {
      this.$refs.cropper.getCropData(cropperData => {
        this.previewImg = cropperData
      })
    },
    submitImage() {
      this.$refs.cropper.getCropBlob(data => {
        this.$emit("save", {
          blob: data,
          file: this.file,
          image: this.previewImg
        })
        this.hiddenCropper()
      })
    },
    hiddenCropper() {
      this.$emit("close")
    }
  }
}
</script>

<style lang="scss" scoped>
.content {
  position: relative;
  padding: 0 30px;
  .cropper-box {
    width: 300px;
    height: 300px;
    margin-right: 15px;
  }
  .preview {
    position: absolute;
    bottom: 0;
    right: 0;
    .preview-name {
      margin-bottom: 8px;
      font-size: 13px;
      color: #666;
    }
    .preview-img {
      display: block;
    }
  }
}
</style>
